import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import PremiumQuoteBenefits from './PremiumQuoteBenefits';
import PremiumQuoteForm from './PremiumQuoteForm';

/**
 * Premium Quote Handler Component
 * - Handles conditional rendering based on user authentication and plan status
 * - Shows PremiumQuoteBenefits for non-logged users or non-Professional users
 * - Shows PremiumQuoteForm for logged-in Professional plan users
 */

export default function PremiumQuoteHandler() {
  const { isAuthenticated, user } = useAuth();

  // Helper function to check if user has Professional plan
  const hasProPlan = () => {
    if (!user || !user.org_memberships) return false;
    
    // Check if any org membership has Professional plan
    return user.org_memberships.some(membership => {
      // Assume plan is stored in membership or we need to check plan_code
      // For now, let's check if they have any plan that includes "Professional" or similar
      return membership.plan_code === 'PROFESSIONAL' || 
             membership.plan_code === 'PRO' ||
             membership.plan_code === 'PREMIUM';
    });
  };

  // Decision logic:
  // 1. If user is not authenticated -> show benefits page
  // 2. If user is authenticated but doesn't have Professional plan -> show benefits page  
  // 3. If user is authenticated AND has Professional plan -> show form page
  
  const shouldShowBenefits = !isAuthenticated || !hasProPlan();

  if (shouldShowBenefits) {
    return <PremiumQuoteBenefits />;
  } else {
    return <PremiumQuoteForm />;
  }
}